import PropTypes from 'prop-types';
import React from 'react';

const MessageReceive = (props) => {
  return (
    <div className="message-line" data-testid="message-received">
      <div
        className="message-receive"
        id={`msg-${props.message.id}`}
        data-aut-test="message-receive-text"
      >
        <div className="message-div">
          <strong>{props.label}</strong>
          <span>{props.children} </span>
        </div>
      </div>
    </div>
  );
};

MessageReceive.propTypes = {
  children: PropTypes.string,
  message: PropTypes.object,
  label: PropTypes.string
};

export default MessageReceive;
